export default __webpack_public_path__ + "static/adorno-c8ee162f78129e820201fc8cf51926d9.png";